import { Injectable } from '@angular/core';
import { ApiService } from './http/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalespersonService {

  constructor(private apiClient: ApiService) {
  }

  getSalespersons(companyId: number): any {
    return this.apiClient.get(`/${companyId}/salesperson/branch/0`);
  }

  getSalespersonsForBranch(companyId: number, branchId: number): any {
    return this.apiClient.get(`/${companyId}/salesperson/branch/${branchId}`);
  }

  getSalesperson(companyId: number, SalespersonId: number): any {
    return this.apiClient.get(`/${companyId}/salesperson/${SalespersonId}`);
  }

  getSupervisors(companyId: number): any {
    return this.apiClient.get(`/${companyId}/salesperson/supervisors`);
  }

  createSalesperson(companyId: number, data): any {
    return this.apiClient.post(`/${companyId}/salesperson`, data);
  }

  updateSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}`, data);
  }

  submitSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/submit`, data);
  }

  cancelSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/cancel`, data);
  }

  sendBackSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/send-back`, data);
  }

  approveSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/approve`, data);
  }

  approveWithConditionSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/approve-condition`, data);
  }


  rejectSalesperson(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/reject`, data);
  }

  saveSalesStructure(companyId: number, salespersonId: number, data): any {
    return this.apiClient.put(`/${companyId}/salesperson/${salespersonId}/structure-team`, data);
  }

  getRequireAttachments(companyId: number): any {
    return this.apiClient.get(`/${companyId}/salesperson/documents`);
  }

  getBranchTeams(companyId: number): Observable<any> {
    return this.apiClient.get(`/${companyId}/salesperson/branch-teams`);
  }

  checkVerify(companyId: number, citizenId: string): Observable<any> {
    return this.apiClient.get(`/${companyId}/salesperson/validate/${citizenId}`);
  }

  removeFileAttachment(companyId: number, attachmentId: number): Observable<any> {
    return this.apiClient.delete(`/${companyId}/salesperson-attachments/remove/${attachmentId}`);
  }
  changeStatus(companyId: number, data: any): any {
    return this.apiClient.put(`/${companyId}/service/salesperson/change-status`, data);
  }

  getProductGroup(companyId: number) : Observable<any>  {
    return this.apiClient.get(`/${companyId}/product-groups`);
  }

  getAllProductGroup(companyId: number) : Observable<any>  {
    return this.apiClient.get(`/${companyId}/product-groups/get-all`);
  }

  saleStructureTeam(companyId: number, citizenid : string) : Observable<any>  {
    return this.apiClient.get(`/${companyId}/salesperson/sale-structure-team/${citizenid}`);
  }

  getSupervisor(companyId: number, saleStructureTeamId : number|string, branchId : number|string, position : string){

    return this.apiClient.get(`/${companyId}/salesperson/supervisor/${saleStructureTeamId}/${branchId}/${position}`);
  }

  checkSalePosition(companyId: number, salesStructureTeamId : number|string, position : string){
    return this.apiClient.get(`/${companyId}/salesperson/check-sale-position/${position}/${salesStructureTeamId}`);
  }
  getBank(companyId: number, type: string): Observable<any> {
    return this.apiClient.get(`/${companyId}/lookups/${type}/list`);
  }

  getPrefix(): any {
    return this.apiClient.getListCache(`/get-prefixes`);
  }

  getSaleTeam(companyId,salesStructureTeamId){

    return this.apiClient.get(`/${companyId}/sales-structures/sale-team/${salesStructureTeamId}`);
  }

  getAllByBranch(companyId, groupBranch): any {
    return this.apiClient.post(`/${companyId}/product-groups/get-all-by-branch`, groupBranch);
  }

  getSalespersonByProductGroupCode(companyId: number, branchId : number, productGroupCode : any): any {
    return this.apiClient.get(`/${companyId}/salesperson/sales-person-permission/${branchId}/${productGroupCode}`);
  }
}
